document.addEventListener("DOMContentLoaded", ()=> {
  const d = document;
  const $calendarOrigin = d.querySelector('.para-profes-page .field--type-entity-reference-revisions .field__item:nth-child(2)');

  if ($calendarOrigin) {
    const $calendar = $calendarOrigin.querySelector('.col-md-8');
    $calendar.classList.add('calendar');
    $calendar.classList.remove('col-md-8')
    const $tabbedViews = d.querySelector('.tabbed-views');
    $tabbedViews.querySelector('.tabbed-views__sub-content').classList.remove('col-lg-6');
    $tabbedViews.querySelector('.container').appendChild(d.importNode($calendar, true));
    $calendarOrigin.remove();
  }
});
